import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import {
  amountComparator,
  cellRenderer,
} from '../../../../SharedModules/utilities/utilities';


function parseMMDDYYYY(v) {
  if (!v || typeof v !== 'string') return Number.POSITIVE_INFINITY; 
  const parts = v.split('/');
  if (parts.length !== 3) return Number.POSITIVE_INFINITY;
  const mm = parseInt(parts[0], 10);
  const dd = parseInt(parts[1], 10);
  const yy = parseInt(parts[2], 10);
  if (!mm || !dd || !yy) return Number.POSITIVE_INFINITY;
  const t = new Date(yy, mm - 1, dd).getTime();
  return isNaN(t) ? Number.POSITIVE_INFINITY : t;
}

function dateComparatorMMDDYYYY(a, b) {
  return parseMMDDYYYY(a) - parseMMDDYYYY(b);
}

function ndcComparator(a, b) {
  function parse(val) {
    if (!val || typeof val !== 'string') return [Number.POSITIVE_INFINITY];
    return val.split('-').map(function (seg) {
      const n = parseInt(seg, 10);
      return isNaN(n) ? Number.POSITIVE_INFINITY : n;
    });
  }

  const A = parse(a);
  const B = parse(b);
  const maxLen = Math.max(A.length, B.length);

  for (let i = 0; i < maxLen; i++) {
    const ai = i < A.length ? A[i] : Number.POSITIVE_INFINITY;
    const bi = i < B.length ? B[i] : Number.POSITIVE_INFINITY;
    if (ai !== bi) return ai - bi;
  }
  return 0;
}

function providerComparator(a, b) {
  const na = parseInt(a, 10);
  const nb = parseInt(b, 10);
  const AA = isNaN(na) ? Number.POSITIVE_INFINITY : na;
  const BB = isNaN(nb) ? Number.POSITIVE_INFINITY : nb;
  return AA - BB;
}


const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

export const ExcludedClaimsTableHead = [
{
    headerName: 'Provider Number',
    field: 'providerId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer: function (params) {
      if (params.data && params.data.isBottomRow) {
        return params.data.providerId;
      }
      if (params.value === 'Paid Date Total:') {
        return <span style={{ fontWeight: 'bold' }}>{params.value}</span>;
      }
      return params.value;
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: providerComparator,
    sort: 'asc',
    sortIndex: 2,
  },
  {
    headerName: 'Provider Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_220,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    columnSpan: 3,

    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
{
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellRenderer: (params) => {
      if (params.data.isBottomRow) {
        return params.value ? params.value?.toLocaleString('en-US') : '';
      }
      return params.value ? params.value?.toLocaleString('en-US') : '0';
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: ndcComparator,
    sort: 'asc',
    sortIndex: 1,
  },
  {
    headerName: 'Drug Qty',
    field: 'numOfUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'NumOfUnitsCellRender',
    exportZeroesFour: true,
    comparator: amountComparator,

    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },

  // {
  //   headerName: 'Drug Qty',
  //   field: 'numOfUnits',
  //   editable: false,
  //   suppressMenu: false,
  //   sortable: true,
  //   minWidth: Styles.Width_138,
  //   // cellRenderer,
  //   cellRenderer: 'GenericCodeTextBox',
  //   cellEditorParams: {
  //     maxLength: 5,
  //     custWidth: '135px',
  //   },
  //   custClass: 'tbill-rate-editable-input',
  //   filter: 'agTextColumnFilter',
  //   filterParams: {
  //     defaultOption: 'startsWith',
  //     suppressAndOrCondition: true,
  //     buttons: ['reset'],
  //     refreshValuesOnOpen: true,
  //   },
  // },
  {
    headerName: 'Billed Amt',
    field: 'submittedAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    // cellRenderer: negativeRenderer,
    cellRenderer: cellRenderer,
    comparator: amountComparator,

    printPrefixValue: '$',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Paid Amt',
    field: 'reimbursementAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    // cellRenderer: negativeRenderer,
    cellRenderer: cellRenderer,
    comparator: amountComparator,

    printPrefixValue: '$',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'TPL Amt',
    field: 'tplAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    // cellRenderer: negativeRenderer,
    cellRenderer: cellRenderer,
    comparator: amountComparator,

    printPrefixValue: '$',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Recipient ID',
    field: 'patientId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    // cellRenderer,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Claim ID',
    field: 'claimId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    // cellRenderer,

    columnSpan: 2,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    // excelAlignment: 'right',
    // alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Service Date',
    field: 'serviceDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_110,
    // cellRenderer,

    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'RX #',
    field: 'prescriptionNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    // cellRenderer,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    alignment: 'right',
    isTextColorRed: true,
  },
{
    headerName: 'Paid Date',
    field: 'paidDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,
    // cellRenderer,
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: dateComparatorMMDDYYYY,
    sort: 'asc',
    sortIndex: 0,
  }
];
export const demo = [];
